{
  "schemaVersion": 1,
  "slug": "linear",
  "name": "Linear",
  "description": "Create, update, and read Linear issues.",
  "categories": [
    "productivity"
  ],
  "featured": true,
  "branding": {
    "logoUrl": "/brands/apps/linear.svg",
    "darkLogoUrl": "/brands/apps/linear-dark.svg"
  },
  "urlPatterns": [
    "https://mcp.linear.app/*"
  ],
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use the provider-hosted connection for the quickest setup.",
      "defaults": {
        "serverUrl": "https://mcp.linear.app/mcp",
        "authorizationEndpoint": "https://linear.app/oauth/authorize",
        "tokenEndpoint": "https://api.linear.app/oauth/token",
        "scopesHint": [
          "read",
          "write"
        ]
      },
      "guidanceMd": "Register a Linear OAuth app and add Paperclip's redirect URI before connecting.",
      "riskTier": "S2",
      "requiredResourceFilters": [
        "workspace",
        "team",
        "project"
      ],
      "credentialSources": {
        "vercelConnect": {
          "services": [
            "linear"
          ],
          "principalModes": [
            "user"
          ],
          "scopes": [
            "read",
            "write"
          ],
          "header": {
            "name": "Authorization",
            "prefix": "Bearer "
          }
        }
      }
    }
  ]
}
